import { render, staticRenderFns } from "./BLoader.vue?vue&type=template&id=6be23862&scoped=true"
import script from "./BLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BLoader.vue?vue&type=style&index=0&id=6be23862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be23862",
  null
  
)

export default component.exports